module.exports = __webpack_public_path__ + "static/media/tokiwa10-5.d1368fe3.jpg";